














































































































































import BaseFormEdit from '../../models/base.form.edit';
import { Component } from 'vue-property-decorator';
import Editor from './Editor.vue';
import axios from 'axios';
import { EventBus } from '@/event-bus';
import Swal from 'sweetalert2';

@Component({ components: { Editor } })
export default class Edit extends BaseFormEdit {
  public urlPrefix = 'pmdd';
  public testMail: string = '';
  public form = { subject: '', message: '', to: '', type: 1, status: '' } as any;
  public types = [{ key: 1, value: 'Сделать рассылку сразу' },
                  { key: 2, value: 'Сделать рассылку в определенное время' }];

  get isDisabled() {
    return this.form.status === 1;
  }

  public created() {
    this.testMail = this.$auth.user().email;
  }

  public async trySendTestMail() {
    if (await this.$validator.validateAll()) {
      this.$root.$emit('bv::show::modal', 'send-mail-modal');
    } else {
      Swal(this.$t('Ошибка') + '', 'Поправьте ошибки на форме' , 'warning');
    }
  }

  public sendTestMail() {
    const self = this;
    axios.post('/mailQueue', { to: this.testMail, subject: this.form.subject, message: this.form.message })
      .then((response: any) => {
          EventBus.$emit('success', { msg: 'Сообщение отправлено на почту: ' + self.testMail });
          this.$root.$emit('bv::hide::modal', 'send-mail-modal');
      })
      .catch((error: any) => {
        EventBus.$emit('error', { msg: error.data });
      });
  }
}
